import React, { FC, memo } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
    margin-top: 8px;
    background-color: #eee;
    padding: 8px;
    font-size: 12px;
`;

const Content = styled.div`
    white-space: pre-wrap;
`;

interface TemplateProps {
    text?: string;
    forwardRef?: React.Ref<HTMLDivElement>;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { text, forwardRef } = props;

    return (
        <Wrapper>
            <Content ref={forwardRef}>{text}</Content>
        </Wrapper>
    );
});

export default Template;
